import { useEffect, useRef, useState } from 'react'
import { LazyAxios, catchError, FacebookIcon, getIframeScr, GroupWhatsappIcon, InstagramIcon, isValidLink, YoutubeIcon, WhatsappIcon } from '../../base'
import { Call, Email, Whatsapp } from '../index'
import { facebook_link, instagram_link, url, whatsapp_channel_link, whatsapp_link } from '../../base/Variables'


function ShopOtherDetails({ shop_id, setShopDetails, setPerror }) {
    const [loading, setLoading] = useState(true)
    const [otherDetails, setOtherDetails] = useState(null)
    const componentRef = useRef(null)
    console.log(shop_id)

    async function getOtherDetails() {
        try {
            const axios = await LazyAxios()
            const request = await axios.get(`${url}/api/v1/shop/${shop_id}/otherDetails/`)
            if (request.data && request.data.data) {
                setOtherDetails(request.data.data)
            }
            else if (request.data && request.data.shop === null) {
                setShopDetails(null)
            }
            setLoading(false)
        }
        catch (error) {
            setPerror(catchError(error).error_message)
        }
    }

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                // Check if the child component is in the viewport
                if (entries[0].isIntersecting && loading) {
                    // Trigger the API call or any function passed as prop
                    if (shop_id) {
                        getOtherDetails()
                    }
                    else {
                        setLoading(false)
                    }
                }
            },
            {
                root: null, // default to the viewport
                threshold: 0.5, // 40% of the component must be visible
            }
        );

        if (componentRef.current) {
            observer.observe(componentRef.current);
        }

        return () => {
            if (componentRef.current) {
                observer.unobserve(componentRef.current);
            }
        };
    }, [shop_id, loading])

    console.log('otehr detailsss', otherDetails)


    return (
        <div className='otherDetails mt-5' ref={componentRef} style={loading ? { minHeight: '900px' } : {}}>
            {
                otherDetails &&
                <div>
                    <div className='h4 stylishFont text-center mb-4 pcolor' style={{ textDecoration: 'underline' }}>Get In Touch</div>
                    <div className='row' style={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                        <div className='col-md-6 col-lg-4 h6'>
                            <Call number={otherDetails.phone_number} color='' />
                        </div>
                        <div className='col-md-6 col-lg-4 h6'>
                            <Whatsapp number={otherDetails.whatsapp_number} color='' />
                        </div>
                        <div className='col-md-6 col-lg-4 h6'>
                            <Email email={otherDetails.email} color='' />
                        </div>

                    </div>
                    <hr />

                    <div className='h4 stylishFont text-center mb-4 pcolor' style={{ textDecoration: 'underline' }}>Join Us On Social Media</div>
                    <div className='socialMedia'>
                        <a href={isValidLink(instagram_link).link} target={isValidLink(instagram_link).target} className='link h6 mt-4'><InstagramIcon />Instagram</a>
                        <a href={isValidLink(whatsapp_link).link} target={isValidLink(whatsapp_link).target} className='link h6 mt-4'><WhatsappIcon />Whatsapp Group</a>
                        <a href={isValidLink(facebook_link).link} target={isValidLink(facebook_link).target} className='link h6 mt-4'><FacebookIcon />Facebook</a>
                        <a href={isValidLink(whatsapp_channel_link).link} target={isValidLink(whatsapp_channel_link).target} className='link h6 mt-4'><GroupWhatsappIcon />Whatsapp Channel</a>
                    </div>
                    <hr />

                    <div className='h4 stylishFont text-center mb-1 pcolor' style={{ textDecoration: 'underline' }}>We Are Located At</div>
                    <div className='text-center'><span className='h6 '>{otherDetails.address_detail}</span> </div>
                    <div className='text-center'><span className='h6 '>Madhya Pradesh, India</span> </div>
                    <div className='map mt-4' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {
                            otherDetails.map_iframe && otherDetails.map_iframe.trim() !== '' &&
                            <iframe src={getIframeScr(otherDetails.map_iframe)} height="400" style={{ "border": 0, width: '100%', maxWidth: '800px' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

                        }
                    </div>
                    <hr />
                </div>
            }

        </div>
    )
}

export default ShopOtherDetails